import { FilePresentOutlined } from '@mui/icons-material';
import React from 'react';
import { getExtension } from '../../fileUploadUtils';

interface Props {
  fileUrl: string;
}
export const DisplayFilePreview: React.FC<Props> = ({ fileUrl }): React.ReactNode => (
  <div
    className="flex h-full w-[90%] mx-auto bg-gray-50 cursor-pointer"
    onClick={() => fileUrl && window.open(fileUrl)}
  >
    <FileContent fileUrl={fileUrl} extension={getExtension(fileUrl)} />
  </div>
);

const FileContent: React.FC<{ fileUrl: string; extension: string }> = ({ fileUrl, extension }) => {
  switch (extension) {
    case '.png':
    case '.jpg':
    case '.jpeg':
      return <img src={fileUrl} alt="Document" className="object-cover w-full h-full" />;

    case '.pdf':
      return (
        <object data={fileUrl} type="application/pdf" className="w-100 h-100 overflow-hidden">
          <p>Error Getting File</p>
        </object>
      );

    case '.docx':
    case '.doc':
      return (
        <div className="flex flex-col items-center my-auto">
          Word <FilePresentOutlined className="w-50 h-50" />
        </div>
      );

    case '.xlsx':
    case '.xls':
      return (
        <div className="flex flex-col items-center my-auto">
          Excel <FilePresentOutlined className="w-50 h-50" />
        </div>
      );

    default:
      return <FilePresentOutlined className="w-50 h-50 mx-auto my-auto" />;
  }
};
